import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { PageTitle, PageContent, PageLead } from 'components/Pages';

const LoadingSection = () => {
    return (
        <section className="page">
            <PageTitle url={`/orders`}>
                <Skeleton width="300px" height="30px" />
            </PageTitle>
            <PageLead>
                <Skeleton width="300px" height="30px" />
            </PageLead>
            <PageContent className="page__content--loading">
                <Skeleton count={12} />
            </PageContent>
            <PageContent className="page__content--loading">
                <Skeleton count={4} />
            </PageContent>
            <PageContent className="page__content--loading">
                <Skeleton count={4} />
            </PageContent>
            <PageContent className="page__content--loading">
                <Skeleton count={4} />
            </PageContent>
            <PageLead size="small">
                <p>
                    Jeśli masz jakiekolwiek pytania dotyczące Twojego zamówienia, prosimy,{' '}
                    <a href="https://garneczki.pl/kontakt">skontaktuj się z nami</a>, odpowiemy możliwie najszybciej!
                </p>
            </PageLead>
        </section>
    );
};

export default LoadingSection;
